import { cloneDeep } from "lodash";
import { ICanvasEditorState, INonUndoableAction } from "../../widgets/interfaces/model/index";
import { PageObjectType } from "../../widgets/interfaces/model/Types";

/**
 * Copy objects action interface
 */
export interface ICopyObjectsAction extends INonUndoableAction {
    selectedObjects: PageObjectType[];
    pasteObjectOffset: number;
    clearOnPaste: boolean;
};

/**
 * Update clipboard objects action interface
 */
export interface IUpdateClipboardAction extends INonUndoableAction {
    pasteObjectOffset: number;
};

/**
 * Update clipboard objects action interface
 */
export interface IResetClipboardAction extends INonUndoableAction {
};

/**
 * Copy selected objects to clipboard
 * @param state { ICanvasEditorState } Current state for canvas clipboard reducer
 * @param action { ICopyObjectsAction } Reducer payload to copy clipboard
 * @param action.type {string} Copy action type viz. 'COPY'
 * @returns New state for Canvas editor reducer
 */
export const copy  = (state: ICanvasEditorState["clipboard"], action: ICopyObjectsAction) => {
	const newState: ICanvasEditorState["clipboard"] = cloneDeep(state);
	const selectedObjects = cloneDeep(action.selectedObjects);
	// if it's cut operation no need to update the offset
	if (!action.clearOnPaste) {
		selectedObjects.forEach((pageObjects) => {
			pageObjects.spPr.xfrm.off.x += action.pasteObjectOffset;
			pageObjects.spPr.xfrm.off.y += action.pasteObjectOffset;
		});
	}
	newState.clipboard = selectedObjects;
	newState.clearOnPaste = action.clearOnPaste;
	return newState;
};

/**
 * Update clipboard objects offset by 20
 * @param state {ICanvasEditorState} Current state for canvas clipboard reducer
 * @param action {IUpdateClipboardAction} Reducer payload to update clipboard
 * @returns New state for Canvas editor reducer
 */
export const updateClipboard  = (state: ICanvasEditorState["clipboard"], action: IUpdateClipboardAction) => {
	const newState: ICanvasEditorState["clipboard"] = cloneDeep(state);
	newState.clipboard.forEach((pageObjects) => {
		pageObjects.spPr.xfrm.off.x += action.pasteObjectOffset;
		pageObjects.spPr.xfrm.off.y += action.pasteObjectOffset;
	});
	return newState;
};

/**
 * Reset clipboard
 * @param state {ICanvasEditorState} Current state for canvas clipboard reducer
 * @param action {ICopyCanvasAction} Reducer payload to reset clipboard
 * @param action.type {string} Copy action type viz. 'RESET_CLIPBOARD'
 * @returns New state for Canvas editor reducer
 */
export const resetClipboard  = (state: ICanvasEditorState["clipboard"], action: IResetClipboardAction) => {
	const newState: ICanvasEditorState["clipboard"] = cloneDeep(state);
	newState.clipboard.length = 0;
	return newState;
};
